import { patchState, signalStoreFeature, withMethods, withState } from '@ngrx/signals';

type Pagination = {
    pageSize: number;
    pageIndex: number;
};

const initialState: Pagination = {
    pageSize: 10,
    pageIndex: 0,
};

export function withPagination() {
    return signalStoreFeature(
        withState(initialState),
        withMethods((store) => ({
            updatePageSize(pageSize: number) {
                patchState<Pagination>(store, { pageSize });
            },
            updatePageIndex(pageIndex: number) {
                patchState<Pagination>(store, { pageIndex });
            },
        }))
    );
}
